import CurrentPageEntity from "@/model/entities/resource/entity/CurrentPageEntity";

export default {
    currentPage: CurrentPageEntity,
    validation: {
        validationCreate: false,
        validationRead: false,
        validationUpdate: false,
        validationDelete: false
    },
    relationPages: [],
    subValidations: [],
    generalFieldsCustomizable: [],
    viewFields: [],
    renderRules:{},
}